package com.ervasstudio.tracoemovimento.pages.blog

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.model.BlogPost
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors.Black
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
fun ListaPosts(post: BlogPost, onClick: (post:BlogPost) -> Unit) {

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .onClick { onClick(post) }
            .cursor(Cursor.Pointer)
    ) {

        Box(
            modifier = Modifier.fillMaxWidth().borderRadius(8.px),
            contentAlignment = Alignment.BottomCenter // Alinha o overlay na base
        ) {
            Image(
                modifier = Modifier.fillMaxWidth()
                    .objectFit(ObjectFit.Cover), // Preenche mantendo a proporção
                src = post.heroshoot.toString(),
            )


            Box(
                modifier = Modifier.fillMaxWidth().padding(
                    top = 6.cssRem, bottom = 1.cssRem, leftRight = 1.cssRem
                ) // Mais padding no topo para o gradiente respirar
                    .styleModifier {
                        // Gradiente de preto opaco na base (0%) para totalmente transparente no topo (100%)
                        property(
                            "background",
                            "linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 100%)"
                        )
                    },
            ) {
                SpanText(
                    modifier = Modifier.color(White).fontFamily("Gotham").fontSize(0.8.cssRem)
                        .fontWeight(FontWeight.Bold).textAlign(TextAlign.Start).styleModifier {
                            property("display", "-webkit-box")
                            property("-webkit-line-clamp", "2")
                            //property("-webkit-box-orient", "vertical")
                            property("overflow", "hidden")
                            property("line-height", "1.2")
                        }, text = post.titulo // Dinâmico com o título do post
                )
            }
        }

        SpanText(
            modifier = Modifier.color(Black).fontFamily("museomoderno")
                .fontSize(0.8.cssRem).fontWeight(FontWeight.Bold).textAlign(TextAlign.Start),
            text = post.subtitulo!!
        )

    }

}